import { useFieldContext } from '@/lib/forms/context'
import { cn } from '@/lib/utils'

import { Field, FieldError, FieldLabel } from '../ui/field'
import { Textarea } from '../ui/textarea'

type Props = {
  label: string
  placeholder?: string
  className?: string
}

export const TextareaField = ({ label, placeholder, className }: Props) => {
  const field = useFieldContext<string>()

  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid

  return (
    <Field data-invalid={isInvalid}>
      <FieldLabel
        htmlFor={field.name}
        className="text-foreground text-base font-bold"
      >
        {label}
      </FieldLabel>
      <Textarea
        id={field.name}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => {
          field.handleChange(e.target.value)
        }}
        aria-invalid={isInvalid}
        placeholder={placeholder}
        className={cn('bg-white', className)}
      />
      {isInvalid && <FieldError errors={field.state.meta.errors} />}
    </Field>
  )
}
